import { render, staticRenderFns } from "./HeaderBackground.vue?vue&type=template&id=ad6180b0&scoped=true&"
import script from "./HeaderBackground.vue?vue&type=script&lang=js&"
export * from "./HeaderBackground.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBackground.vue?vue&type=style&index=0&id=ad6180b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6180b0",
  null
  
)

export default component.exports